import { AssetType } from '@/user/User.types';
import { DepositModalType, ModalsStoreType } from '../ModalsStore.types';
import { getVolumeInputModal } from './VolumeInputModal';

export const getDepositModal = (
    modals: ModalsStoreType,
    asset: AssetType,
    value?: bigint,
): DepositModalType => getVolumeInputModal(modals, 'deposit', asset, value);
